import React from 'react';

const CourseContent = ({ modules, activeModule, onModuleSelect }) => {
  return (
    <div className="course-content">
      {modules?.map((module) => (
        <div 
          key={module._id} 
          className={`course-content-item ${activeModule._id === module._id ? 'active' : ''}`}
          onClick={() => onModuleSelect(module)}
        >
          <div className="d-flex align-items-center">
            {/* <span className="me-2">{module.id}.</span> */}
            <span>{module.title}</span>
          </div>
          <div 
            className={`completion-icon ${module.isCompleted ? 'completed' : 'not-completed'}`}
          >
            {module.isCompleted && <i className="bi bi-check"></i>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CourseContent;